import { useMemo } from 'react';
import useSWR from 'swr';
import { ApiKey } from 'api';
import { PrivateChatBulkMessage, Project } from 'types';

const defaultMessages: PrivateChatBulkMessage[] = [];

export const useGetPrivateChatBulkMessages = ({ projectId }: { projectId: Project['id'] }) => {
  const { data, error, isLoading } = useSWR<PrivateChatBulkMessage[]>(
    `${ApiKey.PrivateChatBulkMessage}?projectId=${projectId}`,
  );

  const mappedData = useMemo(() => {
    if (!data) {
      return defaultMessages;
    }
    return data.map((message) => ({
      ...message,
      deliveryDate: message.sendDate || message.startDate,
    }));
  }, [data]);
  return {
    chatGroupMessages: mappedData ?? defaultMessages,
    isLoading,
    error,
  };
};
